/* eslint-disable-next-line @harmony/stencil/no-tailwind-disable */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import {
  arrayOf,
  bool,
  number,
  shape,
  string
} from 'prop-types';
import {
  Card,
  CardBody,
  CardContent,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import classnames from 'classnames';

const RecommendedSearchTitle = ({ header, grow = false }) => (
  <CardTitle
    header={<span className="sui-capitalize sui-line-clamp-2">{header}</span>}
    headerWeight="bold"
    headerVariant="h5"
    actionPosition="center"
    grow={grow}
  />
);

RecommendedSearchTitle.propTypes = {
  header: string.isRequired,
  grow: bool
};

RecommendedSearchTitle.defaultProps = {
  grow: false
};

const RecommendedCategory = ({ categoryData, index }) => {
  const {
    href,
    imageUrl,
    // TODO: Remove category as fallback text in a future story
    category,
    description,
    searchTerm
  } = categoryData;

  const impressionId = '00DEFVALMA00';
  const { ref, clickID } = useImpression({ data: {
    id: impressionId,
    name: 'RecommendedSearches',
    component: 'RecommendedSearches',
    position: (index + 1),
    type: 'product',
    category: searchTerm || category?.at(-1) || '',
  } });

  const contentClasses = classnames('sui-flex', {
    'sui-gap-2': !!description,
  });
  const imageClasses = classnames('sui-aspect-square', {
    'sui-m-4': !description,
  });
  const mainTextWrapperClasses = classnames('sui-basis-3/4 sui-flex sui-grow sui-flex-wrap sui-content-center', {
  });

  return (
    <div
      id="maa-recommended-search"
      className="sui-max-w-[600px]"
      key={index}
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <Card
        href={href}
        orientation="vertical"
        disablePadding={!description}
        className="[&_a>div]:sui-p-3 [&_a>div]:sui-gap-2"
        CardActionAreaProps={{
          target: '_parent'
        }}
      >
        {description && (
          <CardContent initialSize="4/4" disablePadding>
            <RecommendedSearchTitle
              header={searchTerm || category?.at(-1) || 'Related items'}
              grow
            />
          </CardContent>
        )}
        <div className={contentClasses}>
          <div className="sui-basis-1/4 sui-mx-auto">
            <img
              className={imageClasses}
              src={imageUrl}
              width={55}
              height={55}
              alt="product"
            />
          </div>
          <div className={mainTextWrapperClasses}>
            {description ? (
              <CardBody>
                <Typography variant="body-base" color="subtle">{description}</Typography>
              </CardBody>
            )
              : (
                <RecommendedSearchTitle
                  header={searchTerm || category?.at(-1) || 'Related items'}
                />
              )}
          </div>
        </div>
      </Card>
    </div>
  );
};

RecommendedCategory.propTypes = {
  categoryData: shape({
    imageUrl: string,
    href: string,
    searchTerm: string,
    category: arrayOf(string)
  }).isRequired,
  index: number.isRequired,
};

export { RecommendedCategory };
